import { useState } from "react";
import PropTypes from "prop-types";
import { Checkbox, Icon } from "semantic-ui-react";
import { SuiModal } from "../../common/suiModal";

function BodegaAudienceNotificationModal({ isOpen, onClose }) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const modalContent = (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 16,
        paddingTop: 8,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: -8,
          left: -8,
          background: "#1E63E9",
          color: "#FFFFFF",
          textTransform: "uppercase",
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: 0.5,
          padding: "4px 12px",
          borderRadius: 999,
        }}
      >
        Importante
      </div>

      <div
        style={{
          width: 88,
          height: 88,
          borderRadius: "50%",
          background: "#EEF2FF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        aria-hidden="true"
      >
        <Icon name="users" size="big" style={{ margin: 0, color: "#1E63E9" }} />
      </div>

      <div
        style={{
          fontSize: 20,
          lineHeight: "26px",
          fontWeight: 700,
          color: "rgba(0,0,0,0.87)",
        }}
      >
        Actualización de Audiencias de Bodega Aurrera
      </div>

      <div
        style={{
          fontSize: 14,
          lineHeight: "20px",
          color: "rgba(0,0,0,0.75)",
          textAlign: "left",
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <p style={{ margin: 0 }}>
          Como parte de nuestra evolución digital, Bodega Catálogo Extendido (BA EA) y Bodega
          Despensa (BA OD) se integran en un solo sitio, consolidando la experiencia de compra en
          una única plataforma.
        </p>
        <p style={{ margin: 0 }}>
          Con este cambio, las audiencias de BA EA y BA OD se consolidarán bajo la taxonomía de BA
          (Bodega Aurrera), manteniendo el desglose por departamentos y categorías de acuerdo con la
          nueva estructura del sitio.
        </p>
        <p style={{ margin: 0 }}>
          <strong>¿Qué necesitas hacer?</strong> Si actualmente utilizas audiencias de BA EA o BA OD
          en alguna de tus estrategias, a partir del 22 de septiembre de 2026 revisa su
          disponibilidad y, en caso de que ya no estén disponibles, reemplázalas por las audiencias
          correspondientes de BA. Esto ayudará a asegurar que tus campañas continúen corriendo con
          la segmentación de audiencias deseada.
        </p>
      </div>

      <Checkbox
        checked={dontShowAgain}
        onChange={(_, { checked }) => setDontShowAgain(Boolean(checked))}
        label="No volver a mostrar este mensaje"
        style={{ marginTop: 8 }}
      />
    </div>
  );

  const modalButtons = [
    {
      text: "Cerrar",
      onClick: () => onClose(dontShowAgain),
      props: {
        basic: true,
      },
    },
  ];

  return (
    <SuiModal
      isOpen={isOpen}
      onClose={() => onClose(dontShowAgain)}
      modalSize="tiny"
      hideCloseIcon={false}
      isScrollableModalBody
      isContentLoading={false}
      modalContent={modalContent}
      modalButtons={modalButtons}
    />
  );
}

BodegaAudienceNotificationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BodegaAudienceNotificationModal;
